if (!customElements.get('free-shipping-bar')) {
  class FreeShippingBar extends HTMLElement {
    constructor() {
      super();
      this.threshold = Number.parseInt(this.dataset.thresholdCents, 10) || 0;
      this.moneyFormat = this.dataset.moneyFormat || 'EGP {{amount}}';
      this.fillEl = this.querySelector('[data-free-shipping-fill]');
      this.markerEl = this.querySelector('[data-free-shipping-marker]');
      this.percentEl = this.querySelector('[data-free-shipping-percent]');
      this.messageEl = this.querySelector('[data-free-shipping-message]');
      this.rewardEl = this.querySelector('[data-free-shipping-reward]');
      this.trackEl = this.querySelector('.free-shipping-bar__track');
      this.lastUnlocked = this.classList.contains('free-shipping-bar--unlocked');
      this.unsubscribe = null;
      this.abortController = null;
    }

    connectedCallback() {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          const total = event?.cartData?.total_price;
          Number.isFinite(total) ? this.render(total) : this.fetchCart();
        });
      }
      this.fetchCart();
    }

    disconnectedCallback() {
      if (typeof this.unsubscribe === 'function') this.unsubscribe();
      this.abortController?.abort();
      clearTimeout(this.unlockTimer);
    }

    async fetchCart() {
      this.abortController?.abort();
      this.abortController = new AbortController();

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
          signal: this.abortController.signal
        });
        if (!response.ok) return;
        const cart = await response.json();
        if (Number.isFinite(cart?.total_price)) this.render(cart.total_price);
      } catch (error) {
        if (error.name !== 'AbortError') console.warn('Free shipping bar could not refresh.');
      }
    }

    render(totalPriceCents) {
      if (this.threshold <= 0) return;

      const remaining = Math.max(0, this.threshold - totalPriceCents);
      const progress = Math.min(100, Math.max(0, (totalPriceCents / this.threshold) * 100));
      const rounded = Math.round(progress);
      const unlocked = totalPriceCents >= this.threshold;
      const markerPosition = Math.min(98, Math.max(2, progress));

      this.classList.toggle('free-shipping-bar--unlocked', unlocked);
      this.dataset.progress = String(progress);
      if (this.fillEl) this.fillEl.style.width = `${progress}%`;
      if (this.markerEl) this.markerEl.style.left = `${markerPosition}%`;
      if (this.percentEl) this.percentEl.textContent = `${rounded}%`;
      if (this.trackEl) this.trackEl.setAttribute('aria-valuenow', String(rounded));

      if (this.rewardEl) {
        this.rewardEl.textContent = unlocked ? 'Unlocked' : `${this.formatMoney(this.threshold)} goal`;
      }

      if (this.messageEl) {
        this.messageEl.textContent = unlocked ? this.dataset.unlockedMessage : this.dataset.lockedMessage;
      }

      if (unlocked && !this.lastUnlocked) this.animateUnlock();
      this.lastUnlocked = unlocked;
    }

    animateUnlock() {
      this.classList.remove('is-just-unlocked');
      void this.offsetWidth;
      this.classList.add('is-just-unlocked');
      clearTimeout(this.unlockTimer);
      this.unlockTimer = setTimeout(() => this.classList.remove('is-just-unlocked'), 700);
    }

    formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, this.moneyFormat);
      }

      const amount = (cents / 100).toLocaleString('en-EG', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
      return `EGP ${amount}`;
    }
  }

  customElements.define('free-shipping-bar', FreeShippingBar);
}


